<template>
  <div ref="commsList" :class="['comms_list', {'is_empty': !comms.length}]">
    <template v-if="comms.length">
      <comm-log-item
        v-for="comm in futureComms"
        :key="comm.id"
        :comm="comm"
        show-type-icons
        show-user-avatar
      ></comm-log-item>

      <app-divider v-if="futureComms.length" class="my-150">
        <icon-default icon="down"/>
        Scheduled Messages
        <icon-default icon="down"/>
      </app-divider>

      <comm-log-item
        v-for="comm in currentComms"
        :key="comm.id"
        :comm="comm"
        show-type-icons
        show-user-avatar
      ></comm-log-item>

      <div class="flex flex-centered mt-100 mb-150">
        <button-link
          v-if="showLoadMoreButton"
          @click="loadMoreComms"
          :loading="isLoadingMoreComms"
        >Load More Comms</button-link>

        <p v-else class="is-italic is-size-7 has-text-light">-- End of Log --</p>
      </div>
    </template>
    <div v-else>
      <p class="comms_list--empty">
        {{ record ? 'There are comms attached to this lead' : 'There are no unattached comms' }}</p>
    </div>
  </div>
</template>

<script>
import CommLogItem from "../../../components/comms/components/CommLogItem";
import {ENUMS} from "../../../services/enums";

export default {
  name: "InboxContentCommLog",
  components: {CommLogItem},
  props: {
    type: {
      type: Number,
      required: true,
    },
    hasMultipleLeads: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      isLoadingMoreComms: false,
    }
  },
  computed: {
    isNewLead() {
      return this.type === ENUMS.InboxTypeEnum.NewLead.value;
    },
    isInboundComm() {
      return this.type === ENUMS.InboxTypeEnum.InboundComm.value;
    },
    record() {
      if (this.isNewLead) return this.$store.getters["activeInboxLeadItem/record"];
      if (this.isInboundComm) return this.$store.getters["activeInboxInboundCommItem/record"]
    },
    contact() {
      if (this.isNewLead) return this.$store.getters["activeInboxLeadItem/contact"];
      if (this.isInboundComm) return this.$store.getters["activeInboxInboundCommItem/contact"];
    },
    comms() {
      let comms = [];

      if (this.isNewLead) comms = this.$store.getters["activeInboxLeadItem/communicationLogs"];

      if (this.isInboundComm) {
        let inboundComms = this.$store.getters["activeInboxInboundCommItem/communicationLogs"];

        if(this.record) {
          comms = inboundComms.filter(comm => {
            return comm.record_id === this.record.id;
          })
        } else {
          comms = inboundComms.filter(comm => comm.record_id === null);
        }
      }

      return comms.sort((a,b) => new Date(b.scheduled_at) - new Date(a.scheduled_at));
    },
    currentComms() {
      return this.comms.filter(comm => !comm.is_scheduled);
    },
    futureComms() {
      return this.comms.filter(comm => comm.is_scheduled);
    },
    showLoadMoreButton() {
      return this.$store.state.activeInboxInboundCommItem.showMoreCommsButton
    }
  },
  methods: {
    loadMoreComms() {
      this.isLoadingMoreComms = true

      this.$store.dispatch("activeInboxInboundCommItem/getCommLogs", this.contact.id)
        .finally(() => {
          this.isLoadingMoreComms = false
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.comms_list {
  display: flex;
  flex-direction: column-reverse;

  &.is_empty {
    justify-content: center;
    align-items: center;
  }

  &--empty {
    color: $text-light;
    font-style: italic;
  }
}

.empty_message {
  font-size: 1.125rem;
  font-style: italic;
  color: $text-light;
}
</style>
